export const CLOUDFLARE_STREAM_BASE_URL = "https://customer-0x5hsk8lh27fm00g.cloudflarestream.com"
